import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=47758710&scoped=true&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"
import style0 from "./subjects.vue?vue&type=style&index=0&id=47758710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47758710",
  null
  
)

export default component.exports